import {
  DivRegistrationResult,
  PdfPageContent,
  buildResult,
  extractSection,
  getBlocks,
  joinPages
} from './pdfParser';

/** Plain government DIV print (Transactie / Verzekeringsnemer / Verzekeringsinstelling). */
export function parseStandardDiv(
  pages: PdfPageContent[]
): DivRegistrationResult {
  const text = joinPages(pages);
  const blocks = getBlocks(text);

  return buildResult({
    text,
    blocks,
    policyholderSection:
      extractSection(text, 'Verzekeringsnemer', [
        'VOERTUIG',
        'Levering',
        'Opgegeven leveringsadres'
      ]) || extractSection(text, 'VERZEKERINGNEMER', ['VOERTUIG']),
    vehicleBlocks: ['VOERTUIG'],
    plateLabels: ['Nummerplaat'],
    plateBlocks: ['TRANSACTIE', 'GENERAL'],
    brandLabels: ['Merk en commercieel type (D1-D3)'],
    natureLabels: ['Aard van het voertuig (J1)'],
    categoryLabels: ['Bodywork type (J2)', 'Categorie'],
    insurerSection: blocks.VERZEKERINGSINSTELLING || '',
    insurerLabels: ['FSMA-nummer van de maatschappij', 'FSMA'],
    insurerBlocks: ['VERZEKERINGSINSTELLING'],
    dateLabels: ['Datum en tijd van de inschrijving'],
    dateBlocks: ['TRANSACTIE', 'GENERAL']
  });
}

export function isStandardDivDocument(text: string): boolean {
  return (
    /\bTransactie\b/i.test(text) ||
    (/\bVerzekeringsnemer\b/i.test(text) &&
      /\bVerzekeringsinstelling\b/i.test(text))
  );
}
